/** @jsx h */
import { h } from 'preact'
import AnimalWelfare from './icons/AnimalWelfare'
import EnvironmentalImpact from './icons/EnvironmentalImpact'
import HealthNutrition from './icons/HealthNutrition'
import SafetyQuality from './icons/SafetyQuality'
import SocialImpact from './icons/SocialImpact'

import getThemeClass from './getThemeClass'

const icons = {
  animal: <AnimalWelfare />,
  environmental: <EnvironmentalImpact />,
  health: <HealthNutrition />,
  safety: <SafetyQuality />,
  social: <SocialImpact />
}

const ClaimIcon = props => {
  const { theme } = props

  const icon = icons[getThemeClass(theme)]

  return <div>{icon}</div>
}

export default ClaimIcon
